import { ScmProjectionLogs } from "./ScmAnalysesList";

export default {
  list: ScmProjectionLogs,
};
